import React, { PropTypes } from 'react';

import DraggableLayer from './DraggableLayer';

export class Main extends React.Component {

	componentWillMount() {
		this.props.actions.getMapLayers();
	}
	
	saveUi() {
		return (
			<div style={{'display': 'flex', alignItems: 'center', marginTop: '20px'}}>
				<button 
					type="button" 
					className="btn btn-primary btn-lg"
					disabled={(this.props.mapLayers.isSaving )}
					onClick={() => {
						this.props.actions.Save(this.props.mapLayers.layers);
					}}>
					Salvar
				</button>
				<span style={{marginLeft: '10px'}}>
					{this.props.mapLayers.saveMessage}
				</span>
			</div>
		);
	}

	renderLoading() {
		if ( this.props.mapLayers.isFetching ) {
			return (
				<div style={{display: "flex"}}>
					<span style={{margin: "auto"}}>
						Carregando árvore
						&nbsp;
						<i className="fas fa-circle-notch fa-spin fa-fw" />
					</span>
				</div>
			);
		}
	}

	renderTree() {
		if ( this.props.mapLayers.isFetching === false ) {
			return (
				<div>
					<div id='map-layers-tree-view'>
						{this.props.mapLayers.layers.map((item, i) =>
							<DraggableLayer 
								key={item.id}
								index={i}
								layer={item}
								layers={this.props.mapLayers.layers}
								changeOneMapLayer={this.props.actions.changeOneMapLayer}
								setMapLayers={this.props.actions.setMapLayers}
							/>
						)}
					</div>
					{this.saveUi()}
				</div>
			);
		}
	}
		
	render () {
		return (			
			<div className="row">
				<div className="col-sm-12">
					<div className="panel panel-default">
						<div className="panel-body">
							<div>
								<h2 style={{textAlign: "center"}} >Gerenciar Camadas do GIS</h2>
								<hr />
								<p style={{textAlign: "center"}}>
									Aqui é possível reordenar a as camadas que são exibidas no explorer.
								</p>	
								<br></br>
								{this.renderLoading()}
								{this.renderTree()}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

Main.propTypes = {
	actions: PropTypes.object.isRequired,
	mapLayers: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/ManageMaplayer/Main.js